module.exports = __webpack_public_path__ + "img/education_resources.b7951432.svg";